import React from "react";
import GlobalDialog from "../../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Typography } from "@mui/material";
import {
  CancelButton,
  DeleteButton,
} from "../../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { deletAssignedKra } from "../../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";

const DeleteWill = ({ open, setOpen, skill, setDispatchNew }) => {
  const { loading } = useSelector((state) => state.appraisal);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const handleDelete = () => {
    const data = [skill.appraisal_assignment_id];
    dispatch(deletAssignedKra(data)).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        setDispatchNew((prev) => !prev);
        setOpen(false);
      }
    });
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title="Delete Will"
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      content={
        <>
          <Box>
            <Typography>
              Are you sure? you want to delete this will..!
            </Typography>
          </Box>
        </>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <DeleteButton disabled={loading} action={handleDelete} size={"small"}>
            {loading ? "Please Wait.." : "Delete"}
          </DeleteButton>
        </>
      }
    />
  );
};

export default DeleteWill;
